var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { config } from '../../../../config/config';
import { EventTimeService } from '../../../services/event.time.service';
import { ExportService } from '../../../services/export.csv.service';
import { HubApiService } from '../../../services/hub.api.service';
import { CustomDefaultPlaceCategoryStore, EditorChoiceStore, HubExportPdfStore, } from '../../../stores/hub.calendar.store';
import { ExportPdfModalActions, ExportPdfModalData } from './export.pdf.modal.provider';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { LocalStorageService } from '../../../services/localStorageService';
import { isEmptyObject } from '../../../common/extensions';
var ExportPdfModalComponent = /** @class */ (function (_super) {
    __extends(ExportPdfModalComponent, _super);
    function ExportPdfModalComponent(dialogRef, actions, hubApiService, exportService, exportPdfStore, editorChoiceStore, customDefaultPlaceCategoryStore, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.exportService = exportService;
        _this.exportPdfStore = exportPdfStore;
        _this.editorChoiceStore = editorChoiceStore;
        _this.customDefaultPlaceCategoryStore = customDefaultPlaceCategoryStore;
        _this.data = Object.assign({
            isEvent: true,
            category: 'All',
            eventSource: 'All',
            placeSource: 'All',
            isApproved: true,
            isPrintVersion: false,
            page: 1,
            limit: config.searchLimit,
            exportType: 'PDF',
            approvalStatus: 'all'
        }, data);
        _this.editorChoiceStore.infoCommand.takeUntil(_this.isDestroyed).subscribe(function (editorChoice) {
            console.log('editorChoice in pdf', editorChoice);
            _this.editorChoice = editorChoice;
        });
        _this.loadCustomCategories();
        return _this;
    }
    ExportPdfModalComponent.prototype.loadCustomCategories = function () {
        var _this = this;
        setTimeout(function () {
            _this.customDefaultPlaceCategory = LocalStorageService.getCustomDefaultPlaceCategoryFromLocalStorage();
            _this.customDefaultPlaceCategory.toggle = {
                toggle: _this.customDefaultPlaceCategory.toggle,
                dataSource: {
                    businessType: _this.customDefaultPlaceCategory.businessType,
                },
            };
            _this.customDefaultPlaceCategoryStore.CustomDefaultPlaceCategoryCommand.takeUntil(_this.isDestroyed).subscribe(function (category) {
                if (!isEmptyObject(category)) {
                    console.log('receive from', category);
                    if (category.useDefault) {
                        _this.customDefaultPlaceCategory.useDefault = true;
                    }
                }
            });
        }, 2000);
    };
    ExportPdfModalComponent.prototype.selectCustomDefaultPlaceCategory = function (category) {
        console.log('category', category);
        if (typeof category === 'string') {
            this.data.category = category.toString();
            this.data.subTitle = category.toString();
            delete this.data.categoryList;
            delete this.data.category_id;
        }
        else {
            this.data.categoryList = category.categoryList;
            this.data.subTitle = category.title;
            this.data.category_id = category._id;
            delete this.data.category;
        }
        delete this.data.isToBeExport;
        delete this.data.choice;
    };
    ExportPdfModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    ExportPdfModalComponent.prototype.check = function () {
        console.log(this.data.exportType);
        console.log('data.isPrintVersion', this.data.isPrintVersion);
    };
    ExportPdfModalComponent.prototype.sourceFilter = function () {
        var _this = this;
        setTimeout(function () {
            if ((_this.data.isEvent && _this.data.eventSource === 'choice') ||
                (!_this.data.isEvent && _this.data.placeSource === 'choice')) {
                _this.data.choice = true;
                delete _this.data.isToBeExport;
                delete _this.data.categoryList;
            }
            if ((_this.data.isEvent && _this.data.eventSource === 'selected') ||
                (!_this.data.isEvent && _this.data.placeSource === 'selected')) {
                _this.data.isToBeExport = true;
                delete _this.data.choice;
                delete _this.data.categoryList;
            }
        });
    };
    ExportPdfModalComponent.prototype.confirm = function (event) {
        var _this = this;
        if (this.data.isAsync) {
            var oldFunc_1 = event.complete;
            event.complete = function () {
                oldFunc_1();
                _this.dialogRef.close();
            };
            var progressCallback = function (progress) {
                _this.progress = progress;
            };
            if (this.data.from) {
                this.data.from.setHours(0);
                this.data.from.setMinutes(0);
                this.data.from.setSeconds(0);
            }
            if (this.data.to) {
                this.data.to.setHours(0);
                this.data.to.setMinutes(59);
                this.data.to.setSeconds(59);
                var date = EventTimeService.addHours(this.data.to, 23);
                this.data.to = new Date(date);
            }
            if (this.data.exportType === 'CSV' && this.data.approvalStatus) {
                switch (this.data.approvalStatus) {
                    case 'all':
                        this.data.isApproved = undefined;
                        break;
                    case 'approved':
                        this.data.isApproved = true;
                        break;
                    case 'unapproved':
                        this.data.isApproved = false;
                        break;
                }
            }
            this.exportPdfStore.expoertPdfCommand.next(this.data);
            this.progress = '0%';
            this.actions.confirm(event, progressCallback);
        }
        else {
            this.actions.confirm(event);
            this.dialogRef.close();
        }
    };
    return ExportPdfModalComponent;
}(BaseComponent));
export { ExportPdfModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/export.pdf.modal/export.pdf.modal.component.ts.pre-build-optimizer.js